"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _utils_1 = require("@utils"); // Component
var Padding = function Padding(_ref) {
    var children = _ref.children, className = _ref.className, _ref$id = _ref.id, id = _ref$id === void 0 ? undefined : _ref$id, _ref$halfPadding = _ref.halfPadding, halfPadding = _ref$halfPadding === void 0 ? false : _ref$halfPadding;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        className: className
    }, {
        id: id,
        halfPadding: halfPadding
    }), children);
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Padding__Wrapper",
    componentId: "x7oxnm-0"
})(["position:relative;padding:", "px 0;", "{padding:", "px 0;}", "{padding:", "px 0;}", "{padding:", "px 0;}"], function (props) {
    return !!props.halfPadding ? 16 : 32;
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.halfPadding ? 20 : 40;
}, _utils_1.mediaQuery('laptop'), function (props) {
    return !!props.halfPadding ? 24 : 48;
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !!props.halfPadding ? 32 : 64;
}); // Typing
exports.default = Padding;
